import axios from "./api"

const sessionsApi = {
    postSession(data) {
        return axios.post(`/api/sessions/create`, data);
    },
}

export default sessionsApi;
